<template>
  <div class='bat-analysis-energy-costs'>
      <div class='title'>
         <span>Energy</span>
         <span>LCOE</span>
         <span>LCC</span>
      </div>
      <div v-for="(energy,index) in feasibleEnergies" :key="index">
         <div class='energy' :class="{'best-option': energy.isBestOption}">
            <span>{{ energy.name }}</span>
            <span>{{ formatCurrency(energy.lcoe) }}</span>
            <span>{{ formatCurrency(energy.lcc) }}</span>
         </div>
      </div>
   </div>
</template>

<script>
import { formatCurrency } from '../../../../js/ui-helpers';

export default {
   name: 'bat-analysis-energy-costs',
   props: {
      feasibleEnergies: {
         type: Array,
         required: false,
         validator: energies => energies.every(energy=>energy.name && energy.lcoe && energy.lcc),
      }
   },
   methods: {
      formatCurrency(money)
      {
         return formatCurrency(money);
      }
   }
}
</script>

<style lang="scss" scoped>
$border: 1px solid rgba($primary-color, 0.2);
.bat-analysis-energy-costs {
   border-top: $border;
   border-bottom: $border;
   color: $font-color;
   font-size: 0.9em;
   .title, .energy {
      padding: 0.2em 0.6em;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      span {
         display: block;
         line-height: 2;
      }
   }
   .title {
      border-bottom: $border;
      font-weight: 600;
      margin-bottom: 0.3em;
   }
   .energy.best-option {
      position: relative;
      color: whitesmoke;// shade($success-color, 20%);
      background:  mix($primary-color, white, 95%); // mix($success-color, white, 95%);
      &, &::before {
         border-radius: 2px;
      }
      &::before {
         content: 'Best option';
         position: absolute;
         background: white;
         color:  mix($primary-color, white, 95%);
         text-transform: uppercase;
         font-family: $primary-font;
         font-size: 0.65em;
         font-weight: 700;
         right: 0;
         top: 50%;
         padding: 0.3em 0.4em 0.2em 0.4em;
         transform: translate(20%, -50%);
         box-shadow:
            0 0 0 1px rgba($success-color, 1),
            0em 0em 0.4em rgba(white,0.2);
      }
   }
}
</style>